import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectCompanyModalComponent } from './select-company-modal.component';
import { ModalModule } from '../../../controls/modal/modal.module';
import { DropdownModule } from '../../../controls/dropdown/dropdown.module';
import { FormsModule } from '@angular/forms';
import { OptionModule } from '../../../controls/option/option.module';

@NgModule({
  declarations: [SelectCompanyModalComponent],
  exports: [
    SelectCompanyModalComponent
  ],
  imports: [
    CommonModule,
    ModalModule,
    DropdownModule,
    FormsModule,
    OptionModule
  ]
})
export class SelectCompanyModalModule { }
